import { Box, Button, Typography, Fade, Slide, IconButton } from "@mui/material";
import { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import { RootState } from "../../store";
import theme, { getTenant } from "../../theme";
import { checkEmptyObj, checkIf } from "../../utils";
import { set } from "../../store/globalSlice";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../hooks/useLanguage";
import { CrossIcon, EarthIcon } from "../../assets/icons";
import { useTenantAssets } from "../../contexts/TenantAssetsContext";

export default function MobileIndex() {
  const { t, i18n } = useTranslation("mobileIndex");
  const { language, changeLanguage } = useLanguage();
  let [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const invitationCode = searchParams.get("code");
  const user = useSelector((state: RootState) => state.user);
  const welcome = useSelector((state: RootState) => state.global.welcome);
  const tenant = getTenant();
  const { assets } = useTenantAssets();
  const IntroBg = assets?.introBg;
  const isRTL = i18n.language === "ar";
  const [languagePanel, setLanguagePanel] = useState(false);
  const items = [
    {
      title: t("welcomeTitle1"),
      description: t("welcomeDescription1"),
    },
    {
      title: t("welcomeTitle2"),
      description: t("welcomeDescription2"),
    },
    {
      title: t("welcomeTitle3"),
      description: t("welcomeDescription3"),
    },
  ];
  useEffect(() => {
    document.body.style.backgroundColor = theme.palette.text.white;
  }, []);
  return (
    <Box className="mobile-index" p={4}>
      {checkEmptyObj(user) && (
        <IconButton
          onClick={() => setLanguagePanel(true)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "text.fontDarkest",
            display: "flex",
            alignItems: "flex-start",
            gap: "4px",
            backgroundColor: "text.base50",
            borderRadius: "8px",
            padding: "8px 12px",
          }}
        >
          <Typography sx={{ fontSize: "14px", fontWeight: 600, lineHeight: "20px" }}>
            {language === "ar" ? t("arabic") : t("english")}
          </Typography>
          <EarthIcon style={{ marginTop: "3px" }} />
        </IconButton>
      )}
      <Box className="logo-container">{IntroBg && <IntroBg />}</Box>
      {welcome ? (
        <>
          <Box className="button-container">
            {checkEmptyObj(user) ? (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {tenant.name === "rejeem" ? (
                  <>
                    {/* <Link to={`/find-best-plan`}>
                      <Button fullWidth color="primary" variant="contained" disableElevation>
                        {t("findBestPlan")}
                      </Button>
                    </Link> */}
                    <Link to={`${checkIf(invitationCode) ? "/quick-register?code=" + invitationCode : "/join"}`}>
                      <Button fullWidth color="primary" variant="contained" disableElevation>
                        {t("joinNow")}
                      </Button>
                    </Link>
                    <Link to={`${checkIf(invitationCode) ? "/login?code=" + invitationCode : "/login"}`}>
                      <Button variant="outlined" fullWidth disableElevation>
                        {t("login")}
                      </Button>
                    </Link>
                  </>
                ) : (
                  <>
                    {tenant.name !== "diet-center" && (
                      <Link to={`/plans`}>
                        <Button fullWidth color="primary" variant="contained" disableElevation>
                          {t("explorePlans")}
                        </Button>
                      </Link>
                    )}
                    <Link to={`${checkIf(invitationCode) ? "/login?code=" + invitationCode : "/login"}`}>
                      <Button variant="outlined" fullWidth disableElevation>
                        {t("loginJoinNow")}
                      </Button>
                    </Link>
                  </>
                )}
              </Box>
            ) : (
              <Link to={`/meal-plan`}>
                <Button sx={{ borderRadius: "12px" }} fullWidth color="primary" variant="outlined" disableElevation>
                  {t("manageYourMealPlan")}
                </Button>
              </Link>
            )}

            <Link to={`/dietitian-appointment`}>
              <Typography
                sx={{
                  padding: "16px",
                  color: "text.fontDark",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "20px",
                  textAlign: "center",
                }}
              >
                {t("bookDietitianAppointment")}
              </Typography>
            </Link>
          </Box>
          <Typography component={"span"}>
            {t("footer:copyright", { year: new Date().getFullYear(), brandName: tenant.title })}
          </Typography>
          <Box>
            {tenant.name === "rejeem" && (
              <>
                <Link to="/about">{t("about")}</Link>
                <a>|</a>
              </>
            )}
            <Link to="/privacy">{t("privacyPolicy")}</Link>
            <a>|</a>
            <Link to="/support">{t("support")}</Link>
            <a>|</a>
            <Link to="/contact">{t("contact")}</Link>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ width: "100%", height: "234px" }}>
            <Carousel
              navButtonsAlwaysInvisible={true}
              IndicatorIcon={<Box sx={{ height: "6px", width: "6px", borderRadius: "90px" }}></Box>}
              indicatorIconButtonProps={{
                style: {
                  backgroundColor: "#D0D1D4",
                  width: "6px",
                  height: "6px",
                  margin: "0 10px",
                },
              }}
              activeIndicatorIconButtonProps={{
                style: {
                  backgroundColor: theme.palette.secondary.main,
                  width: "24px",
                  borderRadius: "90px",
                  height: "6px",
                },
              }}
            >
              {items.map((item, key) => {
                return (
                  <Box
                    key={key}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "text.fontDarkest",
                        fontSize: "24px",
                        fontWeight: 700,
                        lineHeight: "160%",
                        padding: "0 24px",
                        textAlign: "center",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: "text.fontDefault",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "160%",
                        textAlign: "center",
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                );
              })}
            </Carousel>
          </Box>
          <Box sx={{ position: "absolute", bottom: "16px", right: "16px", left: "16px" }}>
            <Button
              onClick={() => dispatch(set({ welcome: true }))}
              sx={{ borderRadius: "12px" }}
              fullWidth
              color="primary"
              variant="contained"
              disableElevation
            >
              {t("continue")}
            </Button>
          </Box>
        </>
      )}

      {/* Language Selection Panel - Only for Anonymous Users */}
      {checkEmptyObj(user) && (
        <Fragment>
          <Fade in={languagePanel}>
            <Box className="payment-section-bg" onClick={() => setLanguagePanel(false)}></Box>
          </Fade>
          <Slide direction="up" in={languagePanel} mountOnEnter unmountOnExit>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                zIndex: 4,
                position: "fixed",
                maxWidth: "500px",
                margin: "auto",
                right: 0,
                left: 0,
                bottom: 0,
                background: "var(--body-bg)",
                borderTopRightRadius: "16px",
                borderTopLeftRadius: "16px",
                padding: "24px",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <IconButton
                  onClick={() => setLanguagePanel(false)}
                  sx={{
                    position: "absolute",
                    top: 16,
                    ...(isRTL ? { left: 13 } : { right: 13 }),
                    zIndex: 1,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 1)",
                    },
                  }}
                >
                  <CrossIcon />
                </IconButton>
                <Typography
                  sx={{
                    color: "text.fontDarker",
                    fontSize: "18px",
                    fontWeight: "600",
                    lineHeight: "26px",
                    textAlign: isRTL ? "right" : "left",
                  }}
                >
                  {t("selectLanguage")}
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", marginTop: "16px", gap: "8px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px",
                      borderRadius: "12px",
                      border: language === "en" ? "2px solid var(--primary-default)" : "1px solid var(--base-200)",
                      backgroundColor: language === "en" ? "var(--primary-lighter)" : "var(--base-50)",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      changeLanguage("en");
                      setLanguagePanel(false);
                    }}
                  >
                    <Typography
                      sx={{
                        color: "text.fontDarker",
                        fontSize: "16px",
                        fontWeight: language === "en" ? "600" : "500",
                        lineHeight: "22px",
                      }}
                    >
                      {t("english")}
                    </Typography>
                    {language === "en" && (
                      <Box
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          backgroundColor: "var(--primary-default)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "16px",
                        }}
                      >
                        ✓
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px",
                      borderRadius: "12px",
                      border: language === "ar" ? "2px solid var(--primary-default)" : "1px solid var(--base-200)",
                      backgroundColor: language === "ar" ? "var(--primary-lighter)" : "var(--base-50)",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      changeLanguage("ar");
                      setLanguagePanel(false);
                    }}
                  >
                    <Typography
                      sx={{
                        color: "text.fontDarker",
                        fontSize: "16px",
                        fontWeight: language === "ar" ? "600" : "500",
                        lineHeight: "22px",
                      }}
                    >
                      {t("arabic")}
                    </Typography>
                    {language === "ar" && (
                      <Box
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          backgroundColor: "var(--primary-default)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "16px",
                        }}
                      >
                        ✓
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Slide>
        </Fragment>
      )}
    </Box>
  );
}
